import React from 'react';
import Localization from '../../../config/localization';
import { PaymentArchive } from './PaymentArchive';
import { CityHallStatistics } from './CityHallStatistics';

function PaymentsReportsFooter(props: any) {
  const { isAdmin, doImport } = props;


  return (
    <div className={`mt-5 px-5 d-flex ${isAdmin ? 'justify-content-between' : 'justify-content-end'}`}>
      <PaymentArchive isAdmin={isAdmin} />
      <CityHallStatistics isAdmin={isAdmin} />

      <button className="eon-button bg-eon-red eon-white" onClick={doImport}>
        <span className="px-3">{Localization.paymentsReportsImportButton}</span>
      </button>
    </div>
  );
}

export default PaymentsReportsFooter;